define("checkout/components/alert-banner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="alert o--alert o--alert--{{or @type 'info'}} u--m__t__xs"
    data-test-id="addons-disabled-alert"
    ...attributes
  >
    <span class="o--alert__icon"><i class="i-{{or @type 'info'}}"></i></span>
    <p class="o--alert__text">
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        {{@text}}
      {{/if}}
    </p>
  </div>
  */
  {
    "id": "jEL2t7TK",
    "block": "[[[11,0],[16,0,[29,[\"alert o--alert o--alert--\",[28,[37,0],[[30,1],\"info\"],null],\" u--m__t__xs\"]]],[24,\"data-test-id\",\"addons-disabled-alert\"],[17,2],[12],[1,\"\\n  \"],[10,1],[14,0,\"o--alert__icon\"],[12],[10,\"i\"],[15,0,[29,[\"i-\",[28,[37,0],[[30,1],\"info\"],null]]]],[12],[13],[13],[1,\"\\n  \"],[10,2],[14,0,\"o--alert__text\"],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"      \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[30,3]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@type\",\"&attrs\",\"@text\",\"&default\"],false,[\"or\",\"if\",\"has-block\",\"yield\"]]",
    "moduleName": "checkout/components/alert-banner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});